export default {
    audit: {
        title: 'Audit log',
        recentEvents: 'Recent events',
        search: 'Search audit logs',
        dataChanged: 'Data',
        paginationRecentEvents: 'recent events'
    },
    aboutPage: {
        description: 'About Page text',
        placeholder: 'Enter text',
        latitude: 'Latitude',
        longitude: 'Longitude',
        help: 'You can generate latitude and longitude on ',
        location: 'Location',
        successSaveMessage: 'Page has been successfully updated'
    },
    storePage: {
        title: 'Store page images',
        featuredCollections: 'Featured collections',
        firstCollection: 'First featured collection',
        secondCollection: 'Second featured collection',
        logo: 'Logo',
        cover: 'Cover',
        footer: 'Footer',
        edit: 'Edit',
        cancel: 'Cancel',
        upperSliderImages: 'Upper Slider Images',
        bottomSliderImages: 'Bottom Slider Images',
        maxImages: 'max 5 images',
        save: 'Save',
        successMessage: 'Image deleted successfully!',
        resizeModal: {
            title: 'Resize image'
        },
        deviceModal: {
            title: 'Images for devices',
            default: 'Default',
            tablet: 'Tablet',
            mobile: 'Mobile phone'
        },
        idealDimensions: 'Ideal dimensions',
        idealDimensionsForTablet: 'Ideal dimensions for tablet are',
        idealDimensionsForMobile: 'and for mobile phone',
        aspectRatio: 'aspect ratio'
    },
    storeCategories: {
        title: 'Store Categories',
        update: 'Update',
        successSaveMessage: 'Store Categories have been updated successfully!',
    },
    payment: {
        title: 'Payment',
        requestBtn: 'Request',
        request: 'Request a credit card billing option',
        requested: 'Your credit card billing request is being processed.',
        denied: 'Credit card billing option request denied. If you have any questions contact us at',
        creditCard: 'Credit card',
        cashOnDelivery: 'Cash on delivery'
    },
    storeDescription: {
        title: 'Description',
        update: 'Update',
        placeholder: 'Enter store description',
        successSaveMessage: 'Store Description has been updated successfully!'
    },
    storeOgImage: {
        title: 'OG Image',
        update: 'Update',
        successSaveMessage: 'OG Image have been updated successfully!',
    },
    addresses: {
        title: 'Addresses',
        subtitle: 'List of all locations',
        addAddressButton: 'Add new address',
        successSaveMessage: 'Address has been saved successfully!',
        successDeleteMessage: 'Address has been deleted successfully!',
        modal: {
            addAddress: {
                title: 'New address',
                button: {
                    close: 'Close',
                    addAddress: 'Add new address'
                },
                input: {
                    address: {
                        title: 'Address',
                        placeholder: 'Enter new address'
                    },
                    addressNumber: {
                        title: 'Number',
                        placeholder: '123'
                    },
                    city: {
                        title: 'City',
                        placeholder: 'Enter address city'
                    }
                }
            },
            editAddress: {
                title: 'Update address',
                button: {
                    close: 'Close',
                    updateAddress: 'Save address'
                }
            }
        }
    },
    deleteStore: {
        title: 'Delete Store',
        warningMessage: "Once you delete your account, there is no going back. Please be certain.",
        button: "Delete Account",
        cancel: "Cancel",
        modal: {
            title: "Are you sure you want to do this?",
            deleteDataWarning: "We will immediately delete all of store data including your products data, collections, images, addresses, orders, comments, reviews.",
            emailLabel: "Store name"
        }
    },
    apiTokens: {
        title: 'Api Tokens',
        create: 'Create Token',
        headers: {
            name: 'Name',
            token: 'Token'
        },
        successMessage: 'Token has been successfully copied'
    },
    language: {
        title: 'Language'
    }
};
